// this only supports basic plural handling and first-level y-ending scenarios
// originally ported from LabelModel where it only needed to handle things like 'agent' and 'policy'
function pluralize(word, count) {
  if (count === 1) {
    return word;
  }

  if (word.endsWith('y')) {
    return `${word.slice(0, -1)}ies`;
  }

  return `${word}s`;
}

module.exports = pluralize;
